<template>
  <div class="reportWrapper">
    <template v-if="jsonReady">
      <div class="report-component" id="tr-indicator-type-a-html">
        <div class="two-col-wrapper">
          <!-- begin column one -->
          <div
            class="col-inner background-grey-soft inner-padding rounded-corners-10"
          >
            <template
              v-for="block in helpJsonContent.Root.left_col.highlights_block"
              :key="block"
            >
              <h4 v-if="objectKeyExists(block, 'heading')">
                {{ block.heading.__text }}
              </h4>
              <h4 v-if="objectKeyExists(block, 'forecast')">
                {{ block.forecast.__text }}
              </h4>

              <ul v-if="objectKeyExists(block, 'bullet_1')">
                <template v-for="(value, index) in block" :key="index">
                  <template v-if="!ignore.includes(index)">
                    <li>{{ value.__text }}</li>
                  </template>
                </template>
              </ul>

              <div
                v-if="objectKeyExists(block, 'table')"
                class="table-responsive"
              >
                <table class="tr-data-table darker-borders">
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        {{ block.table.table_head_row[0].head_col_2.__text }}
                      </th>
                      <th>
                        {{ block.table.table_head_row[0].head_col_3.__text }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="(value, index) in block.table.table_head_row"
                      :key="index"
                    >
                      <template v-if="value.col1">
                        <tr>
                          <td>{{ value.col1.__text }}</td>
                          <td style="text-align: center">
                            {{ value.col2.__text }}
                          </td>
                          <td style="text-align: center">
                            {{ value.col3.__text }}
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>

              <p
                v-if="objectKeyExists(block, 'body_copy')"
                v-html="block.body_copy.__text"
              ></p>
            </template>
          </div>
          <!-- end column one -->
          <!-- begin column two -->
          <div class="col-inner inner-padding-top">
            <h4>
              {{
                helpJsonContent.Root.right_col.rate_of_change[0].heading.__text
              }}
            </h4>
            <p>
              <img
                :src="
                  images_path +
                  helpJsonContent.Root.right_col.rate_of_change[0].chart_image
                    ._href
                "
                alt="Trends Report Image"
              />
            </p>

            <h4>
              {{
                helpJsonContent.Root.right_col.rate_of_change[1].heading.__text
              }}
            </h4>
            <p>
              <img
                :src="
                  images_path +
                  helpJsonContent.Root.right_col.rate_of_change[1].chart_image
                    ._href
                "
                alt="Trends Report Image"
              />
            </p>

            <!-- <h4>{{helpJsonContent.Root.right_col.rate_of_change[2].heading.__text}}</h4>
						<ul class="tr-no-bullets">
							<li>
								<a :href="helpJsonContent.Root.right_col.rate_of_change[2].ask_link._href" target="_blank">
									{{helpJsonContent.Root.right_col.rate_of_change[2].ask_link.__text}}
								</a>
							</li>
							<li>
								<a :href="helpJsonContent.Root.right_col.rate_of_change[2].methodology_link._href" target="_blank">
									{{helpJsonContent.Root.right_col.rate_of_change[2].methodology_link.__text}}
								</a>
							</li>
						</ul> -->

            <div class="tr-phase-box" v-bind:class="getPhaseMeta">
              <div class="tr-phase-box--left">
                <img
                  :src="images_path + '/images/' + getPhaseMeta + '.png'"
                  alt="Trends Report Phase Logo"
                />
              </div>
              <div class="tr-phase-box--right">
                <h4>
                  {{
                    helpJsonContent.Root.right_col.rate_of_change[3]
                      .title_reverse.__text
                  }}
                </h4>
                <p
                  v-html="
                    helpJsonContent.Root.right_col.rate_of_change[3].body_copy
                      .__text
                  "
                ></p>
              </div>
            </div>
          </div>
          <!-- end column two -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import moment from 'moment';
  import _ from 'lodash';
  export default {
    props: {
      content: {
        type: String,
        required: false,
      },
      imagespath: {
        type: String,
        required: false,
      },
      issue: {
        type: String,
        required: false,
      },
      fromTr: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        parsed: {},
        jsonReady: true,
        summary: '',
        images_path: this.imagespath,
        ignore: ['heading'],
        jsonContent: JSON.parse(this.content),
      };
    },
    computed: {
      helpJsonContent: function () {
        //return JSON.parse(this.content.replace("\\u2029 | \\u2028", "<br>"));
        return JSON.parse(this.content);
      },

      getPhaseMeta: function () {
        var tempParsePhase = JSON.parse(this.content);
        return tempParsePhase.Root.meta.phase.__text.replace(/_/g, '-');
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      objectKeyExists: function (object_path, key) {
        return this.containsKey(object_path, key);
      },
      containsKey(obj, key) {
        return Object.keys(obj).includes(key);
      },
      getKey: function (object_path) {
        var keyExists = _.get(this.jsonContent, object_path, 0);

        if (keyExists !== 0) {
          return true;
        }
        return false;
      },
      parseJson: function () {
        this.jsonReady = true;
      },

      convertToHyphens: function (value) {
        return value.replace(/_/g, '-');
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
